import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';

interface TimeAgoProps {
  date: string | Date;
}

export const TimeAgo: React.FC<TimeAgoProps> = ({ date }) => {
  const [timeAgo, setTimeAgo] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      const createdAt = new Date(date);
      const now = new Date();
      const diffInSeconds = Math.floor((now.getTime() - createdAt.getTime()) / 1000);

      const seconds = diffInSeconds % 60;
      const minutes = Math.floor((diffInSeconds / 60) % 60);
      const hours = Math.floor((diffInSeconds / 3600) % 24);
      const days = Math.floor(diffInSeconds / 86400);

      const formattedTime = [
        days > 0 ? `${days}d` : '',
        hours > 0 ? `${hours}h` : '',
        minutes > 0 ? `${minutes}m` : '',
        seconds > 0 ? `${seconds}s` : ''
      ].filter(Boolean).join(' '); 

      setTimeAgo(formattedTime);
    }, 1000);

    return () => clearInterval(interval);
  }, [date]);

  return <Box width="120px">{timeAgo}</Box>;
};

